import request from "@/utils/request.js";
// import { message } from 'ant-design-vue'
import { handlerGetUrlParams } from "@/utils/dealUrlParams.js";

//单点登录
export function ssoLogin(params) {
  // const url = handlerGetUrlParams("api/ssoLogin", params);
  return request({
    url: "/ssoLogin",
    method: "get",
    params,
  });
}

//获取bmptoken (图谱)
export function getBpmToken() {
  return request({
    url: "/bpmToken",
    method: "get",
  });
}

// 获取一专利token
export function getPatyeeToken() {
  return request({
    url: "/patyeeToken",
    method: "get",
  })
}

//个人中心
export function getUserInfo() {
  return request({
    url: "/getInfo",
    method: "get",
  });
}

//修改
export function updateUserInfo(data) {
  return request({
    url: "/system/user",
    method: "put",
    data,
  });
}

// 用户管理
// 部门树
export function getDeptTree() {
  return request({
    url: "/system/user/count_dept",
    method: "get",
  });
}

// 部门数据
export function getDeptData(data) {
  const { pageNum, pageSize, ...v } = data;
  const url = handlerGetUrlParams("/system/user/audit_list", {
    pageNum,
    pageSize,
  });
  return request({
    url,
    method: "post",
    data: {
      ...v,
    },
  });
}

//用户添加
export function addUser(data) {
  return request({
    url: "/system/user",
    method: "post",
    data,
  });
}

//用户导出
export function exportUser(data) {
  return request({
    url: "system/user/batch_export",
    method: "post",
    data,
    responseType: "blob",
  });
}

//用户导入
export function impUser(data) {
  return request({
    url: "/system/user/importData",
    method: "post",
    data,
  });
}

//id获取用户
export function getUserById(id) {
  return request({
    url: `/system/user/${id}`,
    method: "get",
  });
}

//编辑用户
export function updateUser(data) {
  return request({
    url: "system/user/edit_by_admin",
    method: "put",
    data,
  });
}

//获取角色列表
export function getRoleList(params) {
  const url = handlerGetUrlParams("/system/role/list", params);
  return request({
    url,
    method: "get",
  });
}

//批量通过或者驳回
export function passReject(data) {
  return request({
    url: "/system/user/batch_audit",
    method: "put",
    data,
  });
}

//状态修改
export function changeUserStatus(data) {
  return request({
    url: "system/user/batchChangeStatus",
    method: "put",
    data,
  });
}

//删除用户
export function deleteUser(id) {
  return request({
    url: `/system/user/${id}`,
    method: "delete",
  });
}

//用户条件查询
export function getUserInfoByTerms(params) {
  const url = handlerGetUrlParams("/system/user/searchBy", params);
  return request({
    url,
    method: "get",
  });
}

//组织管理
export function getDeptList(params) {
  const url = handlerGetUrlParams("/system/dept/list", params);
  return request({
    url,
    method: "get",
  });
}

//详情
export function getDeptDetail(id) {
  return request({
    url: `/system/dept/${id}`,
    method: "get",
  });
}

//获取部门下拉树列表
export function getDeptTreeSelect() {
  return request({
    url: `/system/dept/treeselect`,
    method: "get",
  });
}

//新增部门
export function addDept(data) {
  return request({
    url: `/system/dept`,
    method: "post",
    data,
  });
}

//修改部门
export function updateDept(data) {
  return request({
    url: `/system/dept`,
    method: "put",
    data,
  });
}

//删除部门
export function delDept(id) {
  return request({
    url: `/system/dept/delete/${id}`,
    method: "delete",
  });
}

//获取部门下拉树列表并统计各组织人数
export function depTreeSelectCount(params) {
  //const url = handlerGetUrlParams("/system/dept/count_treeselect", params);
  return request({
    url: "/system/dept/count_treeselect",
    method: "get",
    params,
  });
}

//菜单管理

export function getFrontMenuList() {
  return request({
    url: "/system/menu/userMenu",
    method: "get",
  });
}

//获取列表
export function getMenuList(params) {
  return request({
    url: "/system/menu/treeselect",
    method: "get",
    params,
  });
}

//新增
export function addMenu(data) {
  return request({
    url: "/system/menu/add_article_menu",
    method: "post",
    data,
  });
}

//修改
export function updateMenu(data) {
  return request({
    url: "/system/menu/edit_article_menu",
    method: "put",
    data,
  });
}

//菜单详情
export function getMunuDetail(id) {
  return request({
    url: `/system/menu/${id}`,
    method: "get",
  });
}
